import { createAsyncThunk } from '@reduxjs/toolkit';
import { patchFilePermissionAsDeletedAt } from 'scenes/ProjectBank/services/patchFilePermissionAsDeletedAt.service';
import { selectSelectedProjectId } from 'store/projects/selectors/projectsSelectors';

export const setAsDeletedProjectBankFilePermission = createAsyncThunk(
  'projectBank/deleteProjectBankFilePermission',
  async (filePermissionId, { getState, rejectWithValue }) => {
    try {
      const projectId = selectSelectedProjectId(getState());
      const updatedFilePermission = await patchFilePermissionAsDeletedAt(
        filePermissionId,
        projectId
      );

      return updatedFilePermission;
    } catch (error) {

      const message =
        error.response?.data?.message ||
        error.response?.data?.error ||
        error.response?.data ||
        error.message ||
        'Unknown error';
      return rejectWithValue({ message });
    }
  }
);
